/* Voice orb and controls (rules 47, 50; spec 6.9; states after LiveKit agent-starter-react, MIT, and
   Pipecat, BSD-2-Clause). Reduced motion hides the orb and keeps the static level meter. */
import { Camera, Mic, MicOff, MonitorUp, PhoneOff } from 'lucide-react';
import { AILabel } from './basics';

export type VoiceState = 'connecting' | 'listening' | 'thinking' | 'speaking' | 'muted' | 'reconnecting' | 'ended';

const STATE_TEXT: Record<VoiceState, string> = {
  connecting: 'Connecting…', listening: 'Listening… speak any time', thinking: 'Thinking…', speaking: 'Speaking · interrupt by talking',
  muted: 'Mic muted', reconnecting: 'Reconnecting…', ended: 'Call ended; transcript saved to the chat',
};

export interface VoiceOrbProps {
  state: VoiceState;
  /** 0..1 input or output level. */
  level?: number;
  captions?: string;
  timer?: string;
  muted?: boolean;
  camera?: boolean;
  screen?: boolean;
  onMute?: () => void;
  onCamera?: () => void;
  onScreen?: () => void;
  onEnd?: () => void;
}

export function VoiceOrb(p: VoiceOrbProps) {
  const lvl = Math.max(0, Math.min(1, p.level ?? 0));
  return (
    <section className="voice" data-state={p.state} aria-label="Voice mode" data-cap="VOICE-01" style={{ ['--lvl' as string]: lvl }}>
      <div className="row" style={{ justifyContent: 'center' }}><AILabel />{p.timer && <span className="small muted">{p.timer}</span>}</div>
      <div className="orb" aria-hidden="true" />
      <div className="lvl" aria-hidden="true">{[0, 1, 2, 3, 4].map((i) => <i key={i} />)}</div>
      <div role="status" className="small muted">{STATE_TEXT[p.state]}</div>
      {p.captions && <p className="captions" aria-live="off">{p.captions}</p>}
      <div className="vctl">
        {p.onMute && <button type="button" aria-label={p.muted ? 'Unmute microphone' : 'Mute microphone'} aria-pressed={!!p.muted} onClick={p.onMute}>{p.muted ? <MicOff size={20} aria-hidden="true" /> : <Mic size={20} aria-hidden="true" />}</button>}
        {p.onCamera && <button type="button" aria-label="Camera" aria-pressed={!!p.camera} onClick={p.onCamera} data-cap="VOICE-03"><Camera size={20} aria-hidden="true" /></button>}
        {p.onScreen && <button type="button" aria-label="Share screen" aria-pressed={!!p.screen} onClick={p.onScreen} data-cap="VOICE-04"><MonitorUp size={20} aria-hidden="true" /></button>}
        {p.onEnd && <button type="button" className="end" aria-label="End voice" onClick={p.onEnd}><PhoneOff size={20} aria-hidden="true" /></button>}
      </div>
    </section>
  );
}
